import { Guid } from "../../../utilities/guid";
import { bindable } from "aurelia-templating";
import { autoinject, transient } from "aurelia-dependency-injection";
import * as Enumerable from "linq";
import { NotificationClientService, NotificationType } from "../../../services/basics/notification-client.service";
import { computedFrom } from "aurelia-binding";
import { Reflection } from "../../../utilities/reflection";

@autoinject
@transient()
export class FileUploader {

    private _uri: string;

    public fileInput: HTMLInputElement;

    @bindable
    public identifier: string = Guid.generateGuid();

    @bindable
    public label: string;

    @bindable
    public placeholder: string = "";

    @bindable
    public value: string = "";

    @bindable
    public multiple: boolean;

    @bindable
    public readonly: boolean;

    @bindable
    public disabled: boolean;

    @bindable
    public accept: string = "";

    @bindable
    public files: FileList;

    public filesInternal: FileList;

    @bindable
    public dataUri: string;

    @computedFrom(
        Reflection.getPropertyPath<FileUploader>(z => z._uri),
        Reflection.getPropertyPath<FileUploader>(z => z.value),
        Reflection.getPropertyPath<FileUploader>(z => z.filesInternal),
    )
    get uri(): string {
        if (this.value && !this.filesInternal)
            return this.value;
        if (this.filesInternal && this.filesInternal.length > 0)
            return Enumerable.from(this.filesInternal.length).select(x => this.filesInternal.item(x - 1).name).toArray().join(", ");
        return this._uri;
    }

    set uri(x: string) {
        this.value = null;
        this.filesInternal = null;
        this._uri = x;
        this.dataUri = x;
    }

    constructor(private element: Element, private notificationClientService: NotificationClientService) { }

    attached() {
        $(this.element).find("input:file").change(($event) => {
            const ele: any = $(this.element).find("input:file").get(0);
            this.readURL(ele);
            if (this.checkCorrectFileTypes(ele)) {
                this.files = [].slice.call(ele.files);

                this.element.dispatchEvent(
                    new CustomEvent("on-file-attached",
                        {
                            bubbles: true,
                            detail: {
                                files: ele.files,
                                innerEvent: $event
                            }
                        }));
            } else {
                this.notificationClientService.show("Error", "The file uploaded is not supported", NotificationType.Error)
            }
        });
    }

    public reset() {
        if (this.fileInput) {
            this.fileInput.value = "";
        }
        this.filesInternal = null;
        this.files = null;
        this.uri = "";
        this.value = "";
        this.dataUri = "";
    }

    public remove() {
        this.reset();
        this.element.dispatchEvent(
            new CustomEvent("on-file-attached",
                {
                    bubbles: true,
                    detail: {
                        files: null,
                        innerEvent: null
                    }
                }));
    }

    private checkCorrectFileTypes(ele: any): boolean {
        if (ele.files.length > 0) {
            const acceptList = this.accept != "" ? this.accept.split(',') : [];
            const acceptedFileTypeList = Enumerable.from(acceptList).select(x => x.trim());
            let correctFileType = false;
            for (let i = 0; i < ele.files.length; i++) {
                if (!ele.files[i].type) {
                    correctFileType = true;
                } else {
                    correctFileType = acceptedFileTypeList.count() > 0 ? acceptedFileTypeList.contains(ele.files[i].type) : true;
                }
            }
            return correctFileType;
        }
        return false;
    }

    private readURL(input) {
        if (input.files && input.files[0]) {
            const reader = new FileReader();

            reader.onload = (e) => {
                this.dataUri = (<any>e.target).result;
            }
            reader.readAsDataURL(input.files[0]);
        }
    }

}
